export interface IObject<Type> {
  (arg: Type): Type
}

export const makeHyphensUnbreakable = (text: string) => {
  const unbreakableHyphen = '&#8209;'
  return text.replace(/-/g, unbreakableHyphen)
}

export const getHashOnlyUrl = (url: string): string => {
  return url.replace(new RegExp('/'), '')
}

export const getSearchParameters = (): IObject<string> => {
  const search = window.location.search
  const prmstr = search.substring(1, search.length)
  return prmstr != null && prmstr != '' ? transformToAssocArray(prmstr) : {}
}

const transformToAssocArray = (prmstr: string) => {
  const params = {} as any
  const prmarr = prmstr.split('&')
  for (let i = 0; i < prmarr.length; i++) {
    const tmparr: string[] = prmarr[i].split('=')
    params[tmparr[0]] = decodeURIComponent(tmparr[1])
  }
  return params
}

export const getVariable = (label: string) => {
  const regex = /\%\{(.*?)\}\%/g
  const result = [...label.matchAll(regex)]
  if (!result[0]) return {}
  const [tag, value] = result[0]
  return { tag, value }
}
